













































































import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class Form extends Vue {
  showNameErr: boolean = false;
  showEmailErr: boolean = false;
  showPhoneErr: boolean = false;
  showInquiryErr: boolean = false;
  maxChars = 2000; 
  remChars = 2000;

  exitForm() {
    this.$emit('exitForm');
  }

  mounted() {
    document.getElementById("industry").click();
  }
 
  data() {
    return {
      buttonData: {
        industryPage: [
          'Hospitality',
          'Restaurant',
          'Campus',
          'Other'
        ],
        locationPage: [
          'Los Angeles',
          'Orange County',
          'Riverside', 
          'Other'
        ]
      },
      formData: {
        industry: '',
        location: '',
        contact: {
          name: '',
          email: '',
          phone: '',
          inquiry: '',
        }
      }
    }
  }

  countDown(){
    this.remChars = this.maxChars - this.$data.formData.contact.inquiry.length;
  }

  getIMGURL(blob){
    return require('../assets/images/'+blob)
  }
    
  sendMessage(){
    let form_data = {
      Industry: this.$data.formData.industry,
      Location: this.$data.formData.location,
      Name: this.$data.formData.contact.name,
      Email: this.$data.formData.contact.email,
      Phone: this.$data.formData.contact.phone,
      Inquiry: this.$data.formData.contact.inquiry
    }
    let save = {
      data: [
        form_data
      ]
    }

    Vue.axios.post('https://sheetdb.io/api/v1/i6cc5br98ofm9', save);
    // Vue.axios.get('https://sheetdb.io/api/v1/i6cc5br98ofm9').then(response => (console.log(response)))
  }

	printForm() {
    // validate before sending
    if (this.validate()) {
      // console.log(formData);
      this.sendMessage();
      this.$emit('exitForm');
    } else {
      alert("Please fill up the required items.");
    }
  }

  // Validation Methods
  validate() {
    this.validName(); 
    this.validEmail();
    this.validPhone();
    this.validInquiry();
    let result = !(this.showNameErr || this.showEmailErr || this.showPhoneErr || this.showInquiryErr);

    return result;
  }

  validName() {
    let re = /^[\p{L}'][ \p{L}'-]*[\p{L}]$/u;
    this.showNameErr = (!re.test(this.$data.formData.contact.name.toLowerCase())) || (this.$data.formData.contact.name.length === 0) || (this.$data.formData.contact.name.length > 100);
  }

  validEmail() {
    let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    this.showEmailErr = !re.test(this.$data.formData.contact.email.toLowerCase());
  }

  validPhone() {
    this.showPhoneErr = (this.$data.formData.contact.phone.length == 0) || (this.$data.formData.contact.phone.length > 50);
  }

  validInquiry() {
    this.showInquiryErr = (this.$data.formData.contact.inquiry.length == 0) || (this.$data.formData.contact.inquiry.length > 2000);
  }
  
  pageScrollTo(elemId) {
    // validate current page before scrolling
    let currentPage = document.querySelector(".form-page.active");
    if (elemId !== "industry") {  // do not validate when initializing the form
      if (currentPage.id === "first-page") {
        if (this.$data.formData.industry.length === 0) {
          alert("Please select an industry.");
          return;
        }
      } else if (currentPage.id === "second-page") {
        if (this.$data.formData.location.length == 0) {
          alert("Please select a location.");
          return;
        }
      }
    }

    let target: HTMLElement = document.getElementById(elemId);

    document.querySelectorAll(".nav-bar span").forEach(navBarText => {
      navBarText!.classList.remove("active");
    });
    target.classList.add("active");

    document.querySelectorAll(".form-page").forEach(formPage => {
      let translateValue: string = "0%";
      if (elemId === "location") {
        translateValue = "-100%"
      } else if (elemId === "awesome") {
        translateValue = "-200%"
      }
      (<HTMLElement> formPage)!.style.transform = "translateX(" + translateValue + ")";
      (<HTMLElement> formPage)!.classList.remove("active");
    });
    document.getElementById(target.dataset.target).classList.add("active");
  }

  buttonClickHandler(event:MouseEvent) {
    let target: HTMLElement = <HTMLElement> event.srcElement!;
    let targetText = target.innerText;    
    
    // determine which button was selected then add the selected classname
    var selButtons = document.querySelectorAll(".form-page.active .selected");
    if (selButtons.length > 0) {
      (<HTMLElement> selButtons[0]).classList.remove("selected");
    }
    if (target.classList.contains("form-button")) {
      target.classList.add("selected");
    } else if (target.parentElement.classList.contains("form-button")) {
      target.parentElement.classList.add("selected");
    }

    let toAlert = false;
    var formPage = document.querySelector(".form-page.active");
    if (formPage.id === "first-page") {
      this.$data.formData.industry = targetText;  // update formData object with the value selected
      this.pageScrollTo("location");                   // scroll to the next page
    } else if (formPage.id == "second-page") {
      this.$data.formData.location = targetText;
      this.pageScrollTo("awesome");
    }
  }
}
